<template>
  <figure v-if="src" class="c-image">
    <img :alt="alt" :src="src">
    <figcaption v-if="isText" class="c-image__text" v-html="alt"/>
  </figure>
</template>

<script>
import { props } from '@/components/CImage/props'
import { computed } from 'vue'

export default {
  name: 'CImage',
  props,
  setup (props) {
    return {
      isText: computed(() => !props.alt?.toString().trim().match(/\.[a-zA-Z0-9]{2,4}$/))
    }
  }
}
</script>

<style lang="scss">
@import "style";
</style>
